// @module Eureka.MaxaTrendingProducts.TrendingProcuts
define('Eureka.MaxaTrendingProducts.TrendingProcuts.View'
,	[
	'eureka_maxatrendingproducts_trendingprocuts.tpl'

	,	'Backbone'
	, 	'Profile.Model'
    ]
, function (
	eureka_maxatrendingproducts_trendingprocuts_tpl

	
	,	Backbone
	, 	ProfileModel
)
{
    'use strict';

	// @class Eureka.MaxaTrendingProducts.TrendingProcuts.View @extends Backbone.View
	return Backbone.View.extend({

		template: eureka_maxatrendingproducts_trendingprocuts_tpl

	,	initialize: function (options) {
			let profile  = ProfileModel.getInstance()
			this.isLoggedIn = profile.attributes.isLoggedIn === "T"

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			var self = this;
			//var url = "https://www.maxa-group.com/api/items?custitem_scamax001_trending=T&fieldset=details"
			let currency = (this.isLoggedIn) ? profile.attributes.currency.code: "GBP";
			var url = "https://" + SC.ENVIRONMENT.shoppingDomain + "/api/items?custitem_scamax001_trending=T&fieldset=details&currency=" + currency;
			try {
				let isBrowser = SC.ENVIRONMENT.jsEnvironment === 'browser' && !SC.ENVIRONMENT.isTouchEnabled
				jQuery.ajax(url).done(function (result) {
					let items = []
					console.log(result)
					result.items.forEach(function (item) {
						let rObject = {}
						rObject.sku = item.storedisplayname2
						rObject.inStock = (item.quantityavailable > 0)
						if(item.itemimages_detail.urls) {
							rObject.image = item.itemimages_detail.urls[0].url
						}
						rObject.name = item.displayname
						rObject.price = item.onlinecustomerprice_detail.onlinecustomerprice_formatted
						rObject.itemid = item.itemid
						rObject.urlcomponent = item.urlcomponent
						rObject.isEnvironmentBrowser = isBrowser
						items.push(rObject)
					})
					self.items = items;

					self.render()

				})
			}catch (e) {
				self.render()
			}

		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Eureka.MaxaTrendingProducts.TrendingProcuts.View.Context
	,	getContext: function getContext()
		{
			return {
				items: this.items,
				loggedIn: this.isLoggedIn
			};
		}
	});
});
